import React from 'react'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { useMutation } from 'react-query'
import { useAuth } from 'hooks/useAuth';
import View from './view'

const ResetForm = (props) => {
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()
  const { doReset } = useAuth();

  const mutateReset = useMutation(data => doReset(data), {
    onSuccess: result => {
      if (result?.message === 'email_not_found') {
        enqueueSnackbar('Email address not found', {
          variant: 'error',
        })
      }
      if (result?.message === 'email_sent') {
        enqueueSnackbar(t('reset.success'), {
          variant: 'success',
        })
      }
    },
    onError: (error) => {
      console.error('Password reset failed', error)
      enqueueSnackbar(t('reset.error', error), {
        variant: 'error',
      })
    },
  })

  const onSubmit = data => {
    mutateReset.mutate(data)
  }

  return <View {...props} onSubmit={onSubmit} />
}

export default ResetForm